// Caches how many organizations the current user belongs to, so pages that
// need that count before their API call resolves (onboarding skeleton, the
// org sidebar switcher) can render the right shape immediately instead of a
// generic placeholder. Written after every successful fetch of the user's
// organizations list; read synchronously at component setup time.
//
// Thin, page-specific wrapper around the generic cache — see
// composables/useSkeletonCountCache.js and docs/skeleton_count_caching.md.
import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const KEY = 'organizations_count'
const DEFAULT_COUNT = 3

export function getCachedOrganizationsCount() {
  return getCachedSkeletonCount(KEY, DEFAULT_COUNT)
}

export function setCachedOrganizationsCount(count) {
  setCachedSkeletonCount(KEY, count)
}
